import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Formik } from 'formik'
import moment from 'moment'
import PaginationComponent from '../../../../../components/pagination/pagination.component'
import InnerPageContainer from '../../../../../components/layout/private/inner-page-container.component'
import PureSelect from '../../../../../components/form-components/pure-select.component'
import Button from '../../../../../components/buttons/buttons.component'
import Title from '../../../../../components/typography/title.component'
import PeriodInputs, {
	periodInitialValues
} from '../../../../../components/form-components/period-inputs.component'
import {
	ClubService,
	AdminReportsService
} from '../../../../../services'
import { AsyncSelectInput } from '../../../../../components/form-components/inputs.component'
import { StyledFields } from './styles/fields.style'
import { bindActionCreators } from 'redux'
import { clubReportActions } from './club-report.actions'
import debounce from '../../../../../helpers/debounce.helper'

const plansAllOptions = { id: '', label: 'Todos' }

const filterDateOptions = [
	{ value: 'StartDate', label: 'Adesão' },
	{
		value: 'CancellationDate',
		label: 'Cancelamento'
	},
	{ value: 'LastPayment', label: 'Pagamento' }
]

const recurrenceTypeOptions = [
	{ value: '', label: 'Todos' },
	{ value: 'Monthly', label: 'Mensal' },
	{ value: 'Yearly', label: 'Anual' }
]

const statusOptions = [
	{ value: '', label: 'Todos' },
	{ value: 'Active', label: 'Ativa' },
	{ value: 'PendingPayment', label: 'Pendente' },
	{ value: 'Canceled', label: 'Cancelada' }
]

const initialDateIsOutSideRange = (value, finalDate) =>
	value.isAfter(moment(finalDate, 'DD/MM/YYYY'))

const finalDateIsOutSideRange = (value, initialDate) =>
	value.isBefore(moment(initialDate, 'DD/MM/YYYY'))

class ClubReportPage extends Component {
	state = {
		values: {
			filterDate: filterDateOptions[0].value,
			...periodInitialValues,
			planId: plansAllOptions.value,
			recurrenceType: recurrenceTypeOptions[0].value,
			clientName: '',
			status: statusOptions[1].value
		},
		plansOptions: [],
		isExporting: false
	}

	componentWillMount() {
		ClubService.getPlans().then(plans =>
			this.setState({
				plansOptions: [
					plansAllOptions,
					...plans.map(({ id, name }) => ({
						value: id,
						label: name
					}))
				]
			})
		)
	}

	componentDidMount() {
		this.refs.pagination.reload()
	}

	onSubmit = values => {
		const { isExporting } = this.state

		this.setState({ values })

		isExporting ? this.exportData(values) : this.refs.pagination.reload()
	}

	handleExport = () => {
		this.setState({ isExporting: true }, () => {
			this.refs.form && this.refs.form.submitForm()
		})
	}

	exportData = values => {
		const { exportData } = this.props

		exportData && exportData(values)
		this.setState({ isExporting: false })
	}

	render() {
		const { values, plansOptions } = this.state

		const {
			filterDate,
			initialDate,
			finalDate,
			planId,
			recurrenceType,
			clientName,
			status
		} = this.state.values

		return (
			<InnerPageContainer>
				<Title>Clube Muviflex</Title>
				<h3 className="orange semi-bold">Filtros</h3>
				<Formik
					ref="form"
					initialValues={values}
					onSubmit={this.onSubmit}
					render={props => (
						<form noValidate onSubmit={props.handleSubmit}>
							<StyledFields>
								<PureSelect
									label="Filtrar por data de"
									id="filterDate"
									options={filterDateOptions}
									{...props}
								/>
								<PeriodInputs
									finalDateIsOutSideRange={finalDateIsOutSideRange}
									initialDateIsOutSideRange={initialDateIsOutSideRange}
									{...props}
								/>
								<PureSelect
									label="Plano"
									id="planId"
									options={plansOptions}
									placeholder="Selecione... "
									{...props}
								/>
								<PureSelect
									label="Tipo"
									id="recurrenceType"
									placeholder="Selecione... "
									options={recurrenceTypeOptions}
									{...props}
								/>
								<AsyncSelectInput
									id="clientName"
									className="async-select-field"
									label="Cliente"
									loadOptions={asyncSelectLoadInputs}
									style={{ width: '100%' }}
									{...props}
								/>
								<PureSelect
									label="Situação Assinatura"
									id="status"
									options={statusOptions}
									{...props}
								/>
							</StyledFields>
							<div
								style={{
									display: 'flex',
									justifyContent: 'flex-end',
									marginBottom: '4rem'
								}}>
								<Button
									secondary
									type="button"
									style={{ marginRight: '15px' }}
									onClick={this.handleExport}
									data-permission="44946CD3063E8D321B41FE850FA0E1F2F837B004">
									Exportar
								</Button>
								<Button
									data-permission="161A49ABE0383BF27313F49F345D3493CCBBC301"
									primary
									type="submit">
									Consultar
								</Button>
							</div>
						</form>
					)}
				/>
				<div data-permission="161A49ABE0383BF27313F49F345D3493CCBBC301">
					<PaginationComponent
						ref={'pagination'}
						getData={AdminReportsService.getClubReport}
						headers={[
							{ header: 'Cliente', key: 'client' },
							{
								header: 'Número muviflex',
								key: 'moveflexNumber',
								align: 'center'
							},
							{ header: 'Plano', key: 'plan' },
							{ header: 'Tipo', key: 'type' },
							{ header: 'Data de adesão', key: 'startDate' },
							{ header: 'Último pagamento', key: 'lastPayDay' },
							{ header: 'Próximo pagamento', key: 'nextPayDay' },
							{ header: 'Situação', key: 'status' },
							{ header: 'Data cancelamento', key: 'cancellationDate' }
						]}
						params={{
							filterDate,
							initialDate,
							finalDate,
							planId,
							recurrenceType,
							clientName,
							status,
							sidx: 'clientName'
						}}
						rowsPerPage={100}
					/>
				</div>
			</InnerPageContainer>
		)
	}
}

function asyncSelectLoadInputs(inputValue, callback) {
	debounce(
		300,
		() =>
			AdminReportsService.searchClientsNames({
				Name: inputValue,
				Sidx: 'NAME',
				Sord: 'ASC',
				Page: 1,
				RowsPerPage: 10
			}).then(({ rows }) => {
				callback(
					rows.length
						? rows.map(({ name }) => ({
								value: name,
								label: name
						  }))
						: null
				)
			}),
		'asyncSelectLoadInputs'
	)
}

const mapDispatchToProps = dispatch =>
	bindActionCreators({ exportData: clubReportActions.exportData }, dispatch)

const connectedClubReportPage = connect(
	null,
	mapDispatchToProps
)(ClubReportPage)

export { connectedClubReportPage as ModuleRootComponent }
